import { Controller } from "@hotwired/stimulus";

export default class JsonResponseController extends Controller {
  static targets = ["code", "copyBtn", "copyText"];

  declare codeTarget: HTMLElement;
  declare copyBtnTarget: HTMLButtonElement;
  declare copyTextTarget: HTMLElement;
  declare hasCopyTextTarget: boolean;

  connect(): void {
    // Lazy-load highlight.js for JSON syntax highlighting (only when dropdown opens)
    // Uses dynamic import to avoid adding ~50KB to the main bundle
    if (this.codeTarget && !this.codeTarget.dataset.highlighted) {
      this.highlightCode();
    }
  }

  private async highlightCode(): Promise<void> {
    try {
      const [{ default: hljs }, { default: json }] = await Promise.all([
        import("highlight.js/lib/core"),
        import("highlight.js/lib/languages/json"),
      ]);
      hljs.registerLanguage("json", json);
      hljs.highlightElement(this.codeTarget);
    } catch {
      // hljs not available — plain text is fine
    }
  }

  async copy(): Promise<void> {
    const code = this.codeTarget.textContent?.trim() || "";

    try {
      await navigator.clipboard.writeText(code);

      if (this.hasCopyTextTarget) {
        this.copyTextTarget.textContent = "Copied!";
        setTimeout(() => {
          this.copyTextTarget.textContent = "Copy";
        }, 2000);
      }
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  }
}
